import React, { useEffect, useRef } from "react";
import { Container, Card, Row, Col, Image, Button } from "react-bootstrap";
import AuthNavBar from "./components/nav/AuthNav";
import { useSelector } from "react-redux";
import CardBackground from "./assets/cardbackground.png";
import CoatOFArm from "./assets/Madagassca_coat_black_white.png";
import Signature from "./assets/sign.png";
import Flag from "./assets/flag.png";
import "../App.css";
import { useTranslation } from "react-i18next";

const ViewDetails2 = () => {
  const { t } = useTranslation();
  const { userData, loading, error } = useSelector((state) => state.user);

  if (loading) return <h4 className="text-center mt-5">{t("loading")}</h4>;
  if (error) return <h4 className="text-center text-danger mt-5">{error}</h4>;
  if (!userData)
    return (
      <>
        <AuthNavBar />
        <h4 className="text-center text-warning mt-5">{t("no_user_data")}</h4>
      </>
    );

  return (
    <>
      <AuthNavBar />
      <Container>
        <Row style={{ marginTop: "30px" }}>
          <Col>
            <table
              style={{
                width: "630px",
                height: "300px",
                backgroundImage: `url(${CardBackground})`,
                backgroundSize: "cover",
                borderRadius: "30px",
                boxShadow: "1px 2px 4px #999",
              }}
            >
              {/* ... (rest of your table content) ... */}
              <tr>
                <td style={{ width: "60px", paddingLeft: "10px" }}>
                  <Image src={Flag} width={50} height={30} />
                </td>
                <td style={{ width: "530px" }}>
                  <h6 className="fw-bold text-uppercase">
                    Repoblikan’i Madagasikara
                  </h6>
                  <p className="text-muted small">
                    Fitiavana - Tanindrazana - Fandrosoana
                  </p>
                </td>
                <td style={{ width: "60px" }}>
                  <Image src={CoatOFArm} width={50} height={50} />
                </td>
              </tr>
              <tr>
                <td colSpan={3} style={{ textAlign: "center" }}>
                  <h6 className="fw-bold text-uppercase">
                    KARA-PANONDROM-PIRENENA / CARTE NATIONALE D’IDENTITÉ
                  </h6>
                </td>
              </tr>
              <tr>
                <td style={{ width: "200px" }}>
                  <tr>
                    <td style={{ paddingLeft: "10px" }}>
                      <Image
                        src={`data:image/jpeg;base64,${userData.photo}`}
                        width={160}
                        height={180}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "center" }}>
                      <h6 className="fw-bold text-uppercase">{userData.nui}</h6>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "center" }}>
                      <Image
                        src={`data:image/jpeg;base64,${userData.signature}`}
                        width={60}
                        height={40}
                      />
                    </td>
                  </tr>
                </td>
                <td style={{ width: "400px" }}>
                  <td>
                    <td>
                      <span style={{ fontSize: "14px" }}>Anarana / Nom</span>
                      <h6>{userData.firstName}</h6>
                      <span style={{ fontSize: "14px" }}>
                        Fanampin’anarana / Prénoms
                      </span>
                      <h6>{userData.lastName}</h6>
                      <tr>
                        <td style={{ paddingRight: "10px" }}>
                          <span style={{ fontSize: "14px" }}>
                            Daty Nahaterahana / Date de naissance
                          </span>
                          <h6>
                            {new Date(userData.dob).toLocaleDateString("fr-FR")}
                          </h6>
                        </td>
                        <td>
                          <span style={{ fontSize: "14px" }}>
                            LAHY-VAVY / Sexe
                          </span>
                          <h6>
                            {userData.gender === "Male"
                              ? "M"
                              : userData.gender === "Female"
                                ? "F"
                                : userData.gender}
                          </h6>
                        </td>
                      </tr>
                      <span style={{ fontSize: "14px" }}>
                        Toerana nahaterahana / Lieu de naissance
                      </span>
                      <h6>{userData.fokontany}</h6>
                      <span style={{ fontSize: "14px" }}>
                        Natao tamin’ny / Délivré le
                      </span>
                      <h6>
                        {new Date(userData.issuanceDate).toLocaleDateString(
                          "fr-FR",
                        )}
                      </h6>
                    </td>
                  </td>
                </td>
              </tr>
            </table>
          </Col>
          <Col>
            <table
              style={{
                width: "630px",
                height: "300px",
                backgroundImage: `url(${CardBackground})`,
                backgroundSize: "cover",
                borderRadius: "30px",
                boxShadow: "1px 2px 4px #999",
              }}
            >
              {/* ... (rest of your second table content) ... */}
              <tr>
                <td style={{ textAlign: "left", width: "200px" }}>
                  <tr>
                    <td>
                      <Image
                        src={`data:image/jpeg;base64,${userData.qrCode}`}
                        width={200}
                        height={200}
                        style={{ backgroundColor: "transparent" }}
                      />
                    </td>
                  </tr>
                </td>
                <td style={{ textAlign: "left", paddingLeft: "10px" }}>
                  <span style={{ fontSize: "14px" }}>
                    Toerana nahaterahana / Lieu de naissance
                  </span>
                  <h5>
                    {userData.parentFirstname == null
                      ? "-"
                      : userData.parentFirstname}
                  </h5>
                  <span style={{ fontSize: "14px" }}>
                    Toerana nahaterahana / Lieu de naissance
                  </span>
                  <h5>
                    {userData.parentFirstname == null
                      ? "-"
                      : userData.parentFirstname}
                  </h5>
                </td>
              </tr>
              <tr style={{ width: "50px" }}>
                <td
                  colSpan={2}
                  style={{ paddingLeft: "10px", paddingRight: "10px" }}
                >
                  <span style={{ fontSize: "14px", fontWeight: "bold" }}>
                    Tsy azo atao dika mitovy ity pejy ity fa mahavoasazy. / Ne
                    pas copier cette face de la car te sous peine de poursuites.
                  </span>
                  <br />
                  <span style={{ fontSize: "14px" }}>
                    Raha mila fanampiana / Pour obtenir du support : 655 /
                    support@cni.mg
                  </span>
                </td>
              </tr>
              <tr style={{ textAlign: "left", width: "50px" }}>
                <td
                  colSpan={2}
                  style={{
                    textAlign: "center",
                    paddingLeft: "10px",
                    paddingRight: "10px",
                    paddingTop: "25px",
                  }}
                >
                  <p
                    style={{
                      maxWidth: "600px",
                      wordBreak: "break-word",
                      overflowWrap: "break-word",
                      whiteSpace: "normal",
                      paddingRight: "10px",
                      fontSize: "20px",
                      fontFamily: "monospace",
                    }}
                  >
                    {" "}
                    {userData.footerLabel}
                  </p>
                </td>
              </tr>
            </table>
          </Col>
        </Row>
        <Row className="justify-content-center mt-4">
          <Col xs="auto">
            <Button variant="success" onClick={() => window.print()}>{t("print")}</Button>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ViewDetails2;
